

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";



//REMOVE CONSOLE WARINGS 
if (process.env.NODE_ENV === "production") {

  console.warn = () => {};
  console.error = () => {};
}

console.warn = () => {};
console.error = () => {};



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
